import SubmissionsList from "../../SubmissionsList/SubmissionsList";
import { Container } from "puzzle";
import React from "react";
import AdvancedSearchList from "../../SupplierView/AdvancedSearch/AdvancedSearchList";
import { setDocumentTitle } from "../../util/Util";
import TaskGrid from "../TaskGrid/TaskGrid";


export class TaskList extends SubmissionsList {
  /**
   * @inheritDoc
   */
  DRAWER_TABS_MAP = [
    'DETAILS',
    'FILES',
    'SUPPLEMENTARY_FILES'
  ];

  clientView = false;


  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    setDocumentTitle(this.props.title);
  };

  /**
   * @inheritDoc
   */
  getPageCss = (): string => {
    return 'tp-task-list-view';
  };

  /**
   * @inheritDoc
   */
  getTabForSelection = (quotesInView: boolean, filesInView: boolean): string => {
    return filesInView ? 'FILES' : 'DETAILS';
  }

  openClaimTaskDialog = () => {
    this.dispatch('openClaimTaskDialog')
  };

  /**
   * @inheritDoc
   */
  renderContent = () => {
    const { detached } = this.state;
    const { keyboardShortcuts, drawerOption } = this.state;
    const preferencesData = { keyboardShortcuts, drawerOption }

    return <>
      <Container
        htmlTag={'section'}
        tabIndex={0}
        ariaLabel={this.translate('savedSearches')}
        className={'tp-filter-list-wrap'}
      >
        <AdvancedSearchList />
      </Container>
      <TaskGrid
        checkboxSelection={true}
        taskList={true}
        gridSectionAriaLabel={this.translate('SRL-section-table')}
        topSectionAriaLabel={this.translate('SRL-section-actions')}
        detached={detached}
        updateDrawerState={this.detachDrawer}
        emptyGridConfig={{
          text: this.translate('gridEmptyLabel'),
          img: 'subs-grid'
        }}
        searchBarConfig={{
          isClientView: this.clientView,
          initializeUserData: this.props.initializeUserData,
          isDrawerOpen: this.isDrawerOpen()
        }}
        quickFiltersEnabled={true}
        title={this.translate('grid-title')}
        {...preferencesData}
      />
    </>
  }

  /**
   * @inheritdoc
   */
  updateSelectedRecordAfterGridUpdate = () => {
    //Should stayed empty due to override
  }

}
